import React from "react";
import {
  Alert,
  AlertIcon,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalFooter,
  ModalBody,
  ModalHeader,
  ModalCloseButton,
  Button,
  Spinner,
} from "@chakra-ui/core";

const PayOutModal = ({
  status,
  isPayoutError,
  isProcessingPayout,
  reinitialiseState,
  isOpen,
  onClose,
}) => {

  const handleClose = () => {
    reinitialiseState();
    onClose()
  }
  return (
    <>
      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent color="primary.500">
          <ModalHeader fontWeight="bold">
            {isPayoutError
              ? "Error"
              : isProcessingPayout
              ? "Processing"
              : "Success"}
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Alert bg="none" status={isPayoutError ? "error" : "success"}>
              {isProcessingPayout ? (
                <Spinner mx={4} color="success.500" />
              ) : (
                <AlertIcon
                  color={isPayoutError ? "danger.400" : "success.400"}
                />
              )}
              {status}
            </Alert>
          </ModalBody>

          <ModalFooter>
            <Button onClick={handleClose}>Close</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};

export default PayOutModal;
